import makeStyles from '@mui/styles/makeStyles';
import {useSelector} from 'react-redux';
import {Box} from '@mui/material';
import {MainToolbar} from './mainToolbar';

const useStyles = makeStyles((theme) => ({
    root: {
        width: "100%"
    }
}))

export function DocumentListView(props) {
    const classes = useStyles();


    return (
        <Box className={classes.root}>
            <MainToolbar viewerId={props.viewerId} />
            document list
        </Box>
    )
}